export const ORGANIZATION_API_PATH = 'organization';
export const ORGANIZATION_API_TYPE = 'organization';
//# sourceMappingURL=helpers.js.map